import { get, writable } from 'svelte/store';
import { ActivityTypesService } from '../../services/activity-types.service';
import { DossierService } from '../../services/dossier.service';
import { UserTimersService } from '../../services/user-timers.service';
import { user } from '../../app.store';
import { ActivityService } from '../../services/activity.service';
export const loading = writable(false);
export const timers = writable([]);
export const createActivityTimerId = writable(null);
export const activity = writable(null);
export const dossier = writable(null);
export const applyUserRevenue = writable(false);
//export const extraContentVisible = writable<boolean>(false);
export const createActivityModalOpen = writable(false);
export async function load() {
    loading.set(true);
    timers.set([]);
    try {
        loadSettings();
        let res = await UserTimersService.getUserTimerList();
        timers.set(res.payload);
    }
    finally {
        loading.set(false);
    }
}
function loadSettings() {
    let theUser = get(user);
    let _applyUserRevenue = theUser != null ? theUser.regionSettings.applyUserRevenue : false;
    applyUserRevenue.set(_applyUserRevenue === 1);
}
export async function createNewTimer() {
    let dto = {
        description: "Nuovo Timer"
    };
    await UserTimersService.createUserTimer(dto);
    await load();
}
export async function updateTimer(timerId, description) {
    let dto = {
        timerId: timerId,
        description: description
    };
    await UserTimersService.updateUserTimer(dto);
    // do not reload all times (text field loses focus)
    //await load();
}
export async function deleteTimer(timerId) {
    await UserTimersService.deleteUserTimer(timerId);
    await load();
}
export async function createTimerActivity(timerId, newActivity) {
    //await UserTimersService.createActivity(timerId);
    //await load();
    createActivityTimerId.set(timerId);
    activity.set(newActivity);
    dossier.set(null);
    createActivityModalOpen.set(true);
}
export async function fetchDossier(dossierId) {
    let _resp = await DossierService.fetchDossier(dossierId);
    let _dossier = _resp.payload;
    dossier.set(_dossier);
    return _dossier;
}
export async function fetchAtivityType(activityTypeId) {
    let _resp = await ActivityTypesService.fetchActivityType(activityTypeId);
    return _resp.payload;
}
export async function saveTimerActivity(a) {
    let _record = Object.assign({}, a);
    let _tid = get(createActivityTimerId);
    cancelTimerActivity();
    let _resp = await ActivityService.saveActivity(_record);
    await UserTimersService.createActivity(_tid, _resp.payload);
    await load();
}
export function cancelTimerActivity() {
    createActivityModalOpen.set(false);
    createActivityTimerId.set(null);
    activity.set(null);
    dossier.set(null);
}
